import markDeclareService from "./markDeclareService";

const cropMarkDeclareService = [
    ...markDeclareService
]

export default cropMarkDeclareService;